// Tiny inline sparkline using SVG. Values: array of numbers 0-100.
export function Sparkline({ values, width = 100, height = 28, stroke = "#5A8A6A", fill = "#5A8A6A22" }) {
  if (!values || values.length === 0) {
    return (
      <div
        className="flex items-center justify-center text-[9px] text-[#9B9890]"
        style={{ width, height }}
      >
        no data
      </div>
    );
  }
  if (values.length === 1) {
    return (
      <div className="flex items-center justify-center text-[10px] font-semibold" style={{ width, height, color: stroke }}>
        {Math.round(values[0])}%
      </div>
    );
  }
  const max = 100;
  const min = 0;
  const range = max - min || 1;
  const stepX = width / (values.length - 1);
  const points = values.map((v, i) => {
    const x = i * stepX;
    const y = height - ((v - min) / range) * (height - 4) - 2;
    return [x, y];
  });
  const path = points.map((p, i) => (i === 0 ? `M ${p[0]} ${p[1]}` : `L ${p[0]} ${p[1]}`)).join(" ");
  const fillPath = `${path} L ${width} ${height} L 0 ${height} Z`;
  const last = points[points.length - 1];

  return (
    <svg width={width} height={height} className="block">
      <path d={fillPath} fill={fill} />
      <path d={path} fill="none" stroke={stroke} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={last[0]} cy={last[1]} r="2.5" fill={stroke} />
    </svg>
  );
}
